import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import styles from './QuizQuestion.module.scss';

interface Props {
	question: string;
}

export const QuizQuestion: React.FC<Props> = ({ question }) => {
	const questionFront = `${question.substring(0, question.lastIndexOf(' '))} `;
	// this is necessary so that the asterisk doesn't try to go on its own line
	const lastWordWithAsterisk = `${question.split(' ').pop()}*`;

	return (
		<div className={styles.legendWrapper}>
			<Typography variant='h1'>
				{questionFront}
				<span className={styles.span}>{lastWordWithAsterisk}</span>
			</Typography>
			<Typography className={styles.required} variant='body1'>
				* = required
			</Typography>
		</div>
	);
};
